/**
 * Converts a boolean into a number.
 *
 * @param bool input boolean
 * @returns 1 if bool is true, and 0 if false
 */
export function numberFromBool(bool: boolean): number {
  return +bool;
}